var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformcharges1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.53333V0H0V16.4667H2.53333V19H15.2V2.53333H12.6667ZM1.26667 15.2V1.26667H11.4V2.53333H2.53333V15.2H1.26667ZM13.9333 17.7333H3.8V3.8H13.9333V17.7333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96662 5.69995H5.69995V6.96662H6.96662V5.69995Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0333 5.69995H8.23328V6.96662H12.0333V5.69995Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96662 8.65552H5.69995V9.92218H6.96662V8.65552Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0333 8.65552H8.23328V9.92218H12.0333V8.65552Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96662 11.6111H5.69995V12.8778H6.96662V11.6111Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0333 11.6111H8.23328V12.8778H12.0333V11.6111Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96662 14.5669H5.69995V15.8336H6.96662V14.5669Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0333 14.5669H8.23328V15.8336H12.0333V14.5669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformcharges1);
export default __webpack_public_path__ + "static/media/platform charges (1).eedda24f7ffd4ae84d92ef6aea0b41a9.svg";
export { ForwardRef as ReactComponent };